import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<div class={{if @disabled \"hidden\" \"px-3 py-2\"}} ...attributes>\n  {{yield}}\n</div>", {
  moduleName: "@customerio/fly-components/components/fly-accordion/panel.hbs"
});